import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Wrapper = styled(Box)<{ isloading?: string }>`
  border-radius: ${theme.attributes.borderRadius.secondary};
  border: 1px solid ${theme.colors.strokePrimary};
  background: ${theme.colors.legacyBackgroundMedium};
  display: flex;
  align-items: center;
  gap: 20px;
  padding: ${({ isloading }) => (isloading && isloading === 'true' ? '0 !important' : '12px')};
  width: 100%;
  height: 72px;

  html[data-theme='light'] &:not(:hover) {
    background: #fafafb;
  }

  &:hover {
    cursor: pointer;
    background: ${theme.colors.hoverPrimary};

    ${({ isloading }) =>
      isloading &&
      isloading === 'true' &&
      `
        cursor: default;
        background: ${theme.colors.surfaceItemBackground};
    `};
  }

  .details-card-header {
    display: flex;
    align-items: center;
    gap: 22px;

    .MuiTypography-root {
      font-family: ${theme.typography.fontFamily.primary};
      color: ${theme.colors.cta};
      text-align: center;
      font-size: 36px;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 44px;
    }
  }

  .details-card-content {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .MuiTypography-root {
      font-family: ${theme.typography.fontFamily.primary};
      color: ${theme.colors.menuItemText};
      text-align: left;
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  html[data-theme='light'] & {
    &:hover {
      background: #fafafb;
    }
  }
`
